import styled, { css } from 'styled-components';
export const BKJCheckboxWrapper = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  height: 20px;
  min-width: 20px;
  width: 20px;
`;
export const BKJCheckboxDisplay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  cursor: pointer;
  pointer-events: none;
  border-radius: 1px;

  display: -webkit-flex;
  align-items: center;
  justify-content: center;

  ${({ theme, variant }) => theme.checkbox[variant].checked};

  ${({ value, theme, variant }) => {
    return !value && theme.checkbox[variant].unchecked;
}};

  ${({ disabled }) => disabled &&
    css `
      border-color: ${({ theme }) => theme.colors.Grey5};
      background-color: ${({ theme }) => theme.colors.Grey5};
      opacity: 0.5;
      pointer-events: none;
    `};

  svg {
    transform: translate(-0.5px, 0.5px);
  }
`;
export const BKJCheckboxInput = styled.input `
  opacity: 0;
  height: 20px;
  width: 20px;
  margin: 0;
  cursor: pointer;
`;
export const BKJCheckboxLabel = styled.label `
  ${({ theme }) => theme.fonts.PoppinsText};
  margin-left: ${({ theme }) => theme.spacing.Spacing32};
  cursor: pointer;
  ${({ label }) => !label &&
    css `
      display: none;
    `}
`;
//# sourceMappingURL=BKJCheckbox.styled.js.map